import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class SettingsPayoutAddMethodIndexRoute extends Route {
  @service router;

  /** @inheritDoc */
  model() {
    return {
      countries: null,
      payoutMethods: null,
      hyperwalletUser: null,
    };
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    controller.loadCountries.perform();
    controller.loadPayoutMethods.perform();
    controller.loadHyperwalletUser.perform();
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadCountries.cancelAll();
      controller.loadPayoutMethods.cancelAll();
      controller.loadHyperwalletUser.cancelAll();
    }
  }

  /** @inheritDoc */
  activate() {
    super.activate(...arguments);

    const settingsController = this.controllerFor('settings');
    settingsController.set('isUsingLegacySettingsFrame', false);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowSimpleHeader', true);
    applicationController.set('simpleHeaderText', 'Add a payout method');
    applicationController.set('simpleHeaderRightText', 'Cancel');
    applicationController.set('simpleHeaderRightAction', () => {
      this.router.transitionTo('settings.payout');
    });
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);

    const settingsController = this.controllerFor('settings');
    settingsController.set('isUsingLegacySettingsFrame', true);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowSimpleHeader', false);
    applicationController.set('simpleHeaderText', '');
    applicationController.set('simpleHeaderRightText', '');
    applicationController.set('simpleHeaderRightAction', null);
  }
}

export default SettingsPayoutAddMethodIndexRoute;
